import { writable } from 'svelte/store';

const CurrenciesManagerData = {
    currencies_conversion: [],
    is_loading: false,
    fetched: false,
    error: null
};

function createCurrenciesManagerStore() {
    const { subscribe, set, update } = writable(CurrenciesManagerData);

    return {
        subscribe,
        set_data: (data) => update(s => ({ ...s, currencies_conversion: data, fetched: true, is_loading: false })),
        set_loading: (loading) => update(s => ({ ...s, is_loading: loading })),
        set_error: (error) => update(s => ({ ...s, error: error, is_loading: false })),
        reset: () => set(CurrenciesManagerData)
    };
}

export const CurrenciesManagerStore = createCurrenciesManagerStore();

/**
 * Loads currency rates from the API and updates the CurrenciesManagerStore.
 * 
 * @param {string} api_host The base URL of the API (e.g., window.api_host)
 * @returns {Promise<Array>} The fetched currencies conversion data
 */
export async function loadCurrencyRates(api_host) {
    let current_state;
    CurrenciesManagerStore.subscribe(s => current_state = s)();

    if (current_state.fetched || current_state.is_loading) {
        return current_state.currencies_conversion;
    }

    CurrenciesManagerStore.set_loading(true);
    console.log("CurrenciesManagerStore: Fetching rates from", api_host);

    try {
        const response = await fetch(`${api_host}api/getCurrencies`, { method: 'POST' });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        
        const data = await response.json();
        const currencies = data?.data || [];
        
        CurrenciesManagerStore.set_data(currencies);
        console.log("CurrenciesManagerStore: Rates loaded", currencies.length);
        return currencies;
    } catch (error) {
        console.error("CurrenciesManagerStore: Load error", error);
        CurrenciesManagerStore.set_error(error.message);
        throw error;
    }
}
